import axios from "axios";
import { IAdBanner } from "../types/AdTypes";

class AdServerService {
    async getAllBanners(clientId: string): Promise<IAdBanner[]> {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/staticAd/${clientId}`
            );

            return response.data.data;
        } catch (err: any) {
            console.log(
                "There is an error while fetching ad server banners",
                err
            );
            throw new Error(err);
        }
    }

    async getAllRollAds(clientId: string): Promise<any> {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/rollAds/${clientId}`
            )

            return response.data.data.rollAds;
        }catch (err: any) {
            console.log(
                "There was an error fetching the roll ads: ",
                err
            )
        }
    }
}

export const adServerService = new AdServerService();
